import { Brand, Store, Data, Member, Membership } from 'aigens-ng-core';
import { TermsConditionsPage } from '../../dialogs/terms-conditions/terms-conditions';
import { MobileBasePage } from '../../core/base/mobile-base-page';
import { Component, Injector, OnInit } from '@angular/core';
import { RouteTable } from '../../core/route-table';
import {version} from '../../../../package.json';
import { LanguageChoice } from 'src/app/shared/components/language_choice/language_choice';
import { preloaderFinished } from '../../../preloader';
import { IsLoginMemberDialogs } from 'src/app/dialogs/is-login-member/is-login-member';
// import * as firebase from 'firebase/app';
// import * as firebaseui from 'firebaseui';

/**
 * Generated class for the ByodBrandSplashPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
    selector: 'page-byod-brand-splash',
    templateUrl: 'byod-brand-splash.html',
    styleUrls: ['byod-brand-splash.scss']
})
export class ByodBrandSplashPage extends MobileBasePage implements OnInit {

    brand: Brand;
    brandId: number;
    courtId: number;
    paymentStatus: string;
    store: Store;
    login = false;
    slideOpts = {
        initialSlide: 0,
        speed: 400
    };
    langs = [];
    public v: string = version;


    constructor(injector: Injector) {

        super(injector);
        console.log('ByodBrandSplashPage');
        this.brandId = this.getNavParams('brandId');
        this.courtId = this.getNavParams('courtId');
        if (this.courtId) {
            this.orderService.courtId = this.courtId;
            this.orderService.isCourt = true;

            // tmp
            this.configService.isCourt = true;
            this.systemConfigService.getSystemCourtConfig(this.courtId,
                (result) => {
                    console.log('TCL: constructor -> result', result);
                    if (!(result && result.data && result.data.colors)) return;
                    let colors = result.data.colors;
                    this.themeService.setConfigTheme(colors);
                 });
        }

        if (!this.brandId && !this.courtId) {
            this.brandId = 5637145314197504;
            this.navParams.data['brandId'] = this.brandId;
        }
        const store = this.getNavParams('store');

        if (typeof store === 'object') {
            this.store = store;
            // this.storeId = store.id;
            this.setLang(this.store);
        } else {
            // this.storeId = store;
        }
        let paid = this.getNavParams('paid');
        if (!paid) {
            paid = this.navigationService.getNavigationParams()['status'];
        }
        /*if(window.location.href.split("?").length > 1){
            var tmp = window.location.href.split("?")[1]
            let mpgsOBJ=new URLSearchParams(tmp);
            this.paymentStatus = mpgsOBJ.get("status");

        }*/
        const id = this.brandId ? this.brandId : this.courtId;
        this.genSetSession(id.toString(), paid ? () => {
            this.openOrderSummary();
        } : null);

        if (this.courtId) {
            console.log('setting court lang');
            let lang = 'en';
            this.t.use(lang);
            this.t.currentLang = lang;
            this.configService.setLocale(lang);
        }

    }

    ngOnInit() {
        console.log('ByodBrandSplashPage ngOnInit');
        // this.menuController.swipeEnable(false, 'menu1');
        super.ngOnInit();

        this.configService.getPreference('paymentInfo').then((info) => {
            console.log('paymentInfo', info);
            if (info) {
                const orderId = info['orderId'];
                const paymentId = info['paymentId'];
                const lang = info['lang'];
                if (lang && !this.t.currentLang) {
                    this.t.use(lang);
                    this.configService.setLocale(lang);
                }

                this.configService.putPreference('paymentInfo', null);

            }
            // this.getBrand();

        });
        if (this.brandId) {
            this.getBrand();
        } else {
            this.getCourt();
        }

    }

    CJLogin(crmId) {
        // get member by card No
        let card = this.sdkConfigService.getMemberCardNo;
        let hold = this.sdkConfigService.isCrystalJade && card && crmId;

        if (this.sdkConfigService.isCrystalJade) {
            this.memberService.clear();
        }
        if (hold) {
            this.memberApiService.loginWithCardNo(card, crmId).subscribe(member => {
                let m = Data.toData(Member, member);
                let membership = Data.toData(Membership, member['membership'] || {});
                m.membership = membership;
                if (m && m.sessionId) {
                    this.memberService.putMember(m);
                }
            }, err => {
                console.log('JJ: err', err);
                this.showError(err);
            }, () => {
                this.loading(false);
            });
        } else {
            this.loading(false);
        }
    }

    
    clickedSlide(text) {
        console.log('TCL: clickedSlide -> text', text);
        let url = 'https://www.hongkongairport.com/en/';
        switch (text) {
            case 'img1':
                break;
            case 'img2':
                break;
            case 'detail':
                break;
        }
        if (url) {
            window.open(url, '_blank');
        }
    }
    goToLogin() {
        if (this.memberService.getMember()) {

            if (this.systemConfigService.hideStampPage) {
                this.pushByName('ProfileCourtPage', {
                    brand: this.brand
                });
            } else {
                this.pushByName('MemberRewardCourtPage', {
                    brand: this.brand
                });
            }
        } else {
            this.pushByName('LoginCourtPage', {
                courtId: this.courtId,
                features: this.brand.features,
                brand: this.brand,
                country: this.getCourtCountry()
            });
        }

    }
    ionViewWillEnter() {
        super.ionViewWillEnter();
        if (this.brand) {
            this.setTheme(this.brand, this.store);
            console.log('背景图', this.brand.getImage('logo', 360, false));
        }
    }

    ionViewWillLeave() {
        super.ngOnDestroy();
        this.resetTheme();
    }
    presentPopover(ev: any) {

        const inputs = [];

        let langs = this.brand['languages'];
        if (langs && langs.length > 0) {

        } else {
            langs = this.readObject(this.brand, 'brand.stores[0].languages');
        }
        
        this.langs = langs;
        // let langNames = { 'zh': '繁體中文', 'zh-cn': '简体中文', 'en': 'English' };
        const langNames = this.configService.config.langNames;

        if (langs === null || langs.length === 0) return;
        const currentLang = this.t.currentLang;
        for (const lang of langs) {
            inputs.push({
                type: 'radio',
                label: langNames[lang],
                value: lang,
                checked: currentLang === lang
            });
        }
        console.log(inputs);
        const params = {
            inputs, lang: currentLang,
            callBack: (lang) => {
                this.t.use(lang);
                this.configService.setLocale(lang);
            }
        };
        this.showPopoverController(LanguageChoice, params, ev,{ backdropDismiss: true, showBackdrop: false});
    }
    getCourtCountry(){
        let stores = this.brand && this.brand.stores;
        let country;
        if (stores && stores.length > 0) {
            country = stores[0].country;
        }
        return country;
    }
    setLang(store: Store) {

        let newLang = store.language;

        if (!newLang) {

            const langs = store.languages;

            if (langs && langs.length > 0) {
                const lang = langs[0];

                newLang = lang;

            }

        }

        if (newLang && this.t.currentLang !== newLang) {
            this.configService.setLocale(newLang);
            this.t.use(newLang);
        }


    }
    resetTheme() {
        const body = document.getElementsByTagName('BODY')[0];
        body.removeAttribute('id');
    }
    startClicked() {
        // need a flag
        if (this.brandId === 5753217711341568 || this.brandId === 5643682388639744) {
            if (this.brandId === 5643682388639744) {
                this.multOrderManager.enableMutlOrder = true;
            }
            this.pushByUrl(RouteTable['BrandStoreListPage'], { brand: this.brandId }, { relativeTo: this.route });

        } else if (this.courtId) {
            // if (hasmode) { 现在只做不带mode的
            if (this.systemConfigService.checkCourtMemberInStart && !this.memberService.getMember()) {
                this.checkMemberModal();
                return;
            }
            this.orderService.isCourt = true;
            this.pushByUrl(RouteTable['BrandStoreListPage'], {courtId: this.courtId}, {relativeTo: this.route});

            // push to the page to select the modo of dinein or takeaway
            // this.pushByUrl(RouteTable['DineinOrTakeawayPage'], { courtId: this.courtId }, { relativeTo: this.route });

        } else {
            this.configService.getPreference('ssp.isAgreeTerms').then((result) => {
                // if (!result) {
                this.openTermsModal(this.brand, (data) => {
                    this.googleAnalyticEventTrack('enter page');
                    this.pushByUrl(RouteTable['BrandStoreListPage'], {
                        brand: this.brandId,
                        stores: this.brand.stores
                    }, { relativeTo: this.route });
                }, TermsConditionsPage);
                /*} else {

                    this.push(BrandStoreListPage, { brand: this.brandId });
                }*/
            });

        }
    }
    async checkMemberModal() {
        // const options = {showBackdrop: true, backdropDismiss: true};
        const input = {
            ok: () => { this.goToLogin(); },
            cancel: () => {this.pushByUrl(RouteTable['BrandStoreListPage'], {courtId: this.courtId}, {relativeTo: this.route});
        }};

        const modal = await this.modalController.create({
            component: IsLoginMemberDialogs,
            componentProps: input,
            showBackdrop: true,
            backdropDismiss: true,
            cssClass: 'check-court-islogin'
        });
        await modal.present();
        modal.onDidDismiss().then(() => {
            
        });
    }
    async languageClicked() {
        this.googleAnalyticEventTrack('lang');


        const inputs = [];
        const langs = ['zh', 'zh-cn', 'en'];
        const langNames = { 'zh': '繁體中文', 'zh-cn': '简体中文', 'en': 'English' };


        const currentLang = this.t.currentLang;

        for (const lang of langs) {

            console.log(currentLang, lang);

            inputs.push({
                type: 'radio',
                label: langNames[lang],
                value: lang,
                checked: currentLang === lang
            });
        }

        const alert = await this.alertController.create({
            header: this.t.instant('buttons.language'),
            inputs: inputs,
            buttons: [
                {
                    text: this.t.instant('buttons.cancel'),
                    role: 'cancel',
                    handler: data => {

                    }
                },
                {
                    text: this.t.instant('buttons.ok'),
                    handler: lang => {

                        console.log(lang);
                        // to do
                        // this.googleAnalyticEventTrack( 'click', 'select-' + lang);
                        if (lang === currentLang) {
                            return;
                        }


                        this.t.use(lang);
                        this.configService.setLocale(lang);
                        this.getBrand();
                    }
                }
            ]
        });
        alert.present();

    }
    openOrderSummary() {
        this.googleAnalyticEventTrack('order history');
        this.loading(true);
        const id = this.brandId ? this.brandId : this.courtId;
        this.configService.getPreference(id.toString() + '.session').then((session) => {
            this.loading(false);
            if (!session) {
                const subtitle = this.t.instant('global.order-first');
                const confirm = this.t.instant('buttons.ok');

                const alert = this.alertController.create({
                    header: subtitle,
                    buttons: [confirm]
                });
                alert.then(data => data.present());
            } else {

                this.orderService.session = session;
                if (this.multOrderManager.enableMutlOrder || this.courtId) {
                    let page = 'MultiOrderHistoryPage';

                    // TODO: remove history
                    this.pushByName(page, { courtId: this.courtId }).then(() => {
                        // this.navController.remove(removeIndex, 1);
                    });
                } else {
                    this.pushByUrl(RouteTable['MultiOrderHistoryPage'], {}, { relativeTo: this.route });
                }
            }


        });

    }

    getBrand(): void {
        this.loading(true);

        this.menuService.getBrand(this.brandId).subscribe(
            brand => {
                this.loading(false);
                this.brand = brand;
                this.setTheme(this.brand, null);
                preloaderFinished();
            },
            err => console.error(err),
            () => {
                this.loading(false);
                preloaderFinished();
            }
        );


    }

    getCourt(): void {

        this.loading(true);
        this.menuService.getCourt(this.courtId).subscribe(
            brand => {
                this.loading(false);
                this.orderService.courtBrand = brand;
                this.brand = brand;
                this.login = brand && brand.features && brand.features.includes('login');
                this.orderService.login = this.login;
                if (brand['payments'] && brand['payments'].length > 0) { // set payments
                    this.multOrderManager.payments = brand['payments'];
                }
                let langs = this.brand['languages'];
                if (langs && langs.length > 0) {

                } else {
                    langs = this.readObject(this.brand, 'brand.stores[0].languages');
                }
                this.memberService.country = this.brand.stores[0].country;
                this.langs = langs;
                this.setTheme(this.brand, null);
                this.CJLogin(this.brand.crmId);
                preloaderFinished();
            },
            err => console.error(err),
            () => {
                this.loading(false);
                preloaderFinished();
            }
        );

    }

    gotoFAQ() {
        console.log('go to FAQ');
        if (this.courtId)
            this.pushByUrl(RouteTable['BrandFAQPage'], { courtId: this.courtId }, { relativeTo: this.route });
        else {

        }
    }

    protected isAccessPage(): boolean {
        return true;
    }

    public pageName(): string {
        return '/byod-brand-splash';
    }


}
